// ── Email send via Supabase Edge Function ────────────────────────────────────
// Resend domain trademarkmasonry.ca is verified (DKIM + SPF + MX live in DNS),
// so the Edge Function "send-safety-email" sends from safetyinfo@trademarkmasonry.ca
// to PRIMARY_TO (safetyinfo) + csoEmail (if provided) + Salus Pro (when the
// project + submission type match a configured forward).
//
// Migrated from Railway backend on 2026-05-26 after domain verification completed.

async function checkBackendHealth() {
  // Edge Functions don't need a wake-up call. Just confirm the browser has
  // network connectivity — the actual invoke will surface any real failure.
  return navigator.onLine !== false;
}

// PDF buffer → base64 string (no data: prefix). FileReader is used so very
// large PDFs don't blow the call stack (which String.fromCharCode would).
function pdfBufferToBase64(pdfBuffer) {
  const blob = new Blob([pdfBuffer], { type: 'application/pdf' });
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload  = () => resolve(String(reader.result).split(',')[1]);
    reader.onerror = () => reject(new Error('Failed to encode PDF'));
    reader.readAsDataURL(blob);
  });
}

async function submitForm(formData, pdfBuffer, photos) {
  const pdfBase64   = await pdfBufferToBase64(pdfBuffer);
  const pdfFilename = buildFileName(formData);

  // Note: photos are already embedded inside the PDF (canvasCompress @ 800px / 0.55
  // quality). The Edge Function only attaches the PDF, which keeps the request
  // payload small and well under the Supabase Functions size limit.
  const payload = {
    pdfBase64,
    pdfFilename,
    foremanName:   formData.foremanName,
    projectName:   formData.project,
    formType:      formData.submissionType,
    date:          formData.date,
    workersOnSite: formData.workersOnSite || '',
  };

  // Optional CSO email (only if foreman chose "send to safety" and a contact exists)
  if (formData.sendToSafety && formData._csoContact?.cso_email) {
    payload.csoEmail = formData._csoContact.cso_email;
    payload.csoName  = formData._csoContact.cso_name || '';
  }

  const { data, error } = await sbClient.functions.invoke('send-safety-email', {
    body: payload,
  });

  if (error) {
    // Supabase wraps non-2xx responses in FunctionsHttpError. Try to pull the
    // server's JSON error out of context if available.
    let detail = error.message || 'Edge Function error';
    try {
      if (error.context && typeof error.context.json === 'function') {
        const body = await error.context.json();
        detail = body?.details || body?.error || detail;
      }
    } catch {}
    throw new Error(detail);
  }

  if (data?.error) {
    throw new Error(typeof data.error === 'string' ? data.error : 'Send failed');
  }

  // Shape the response so the existing success screen (app.js → showSuccessScreen)
  // continues to work without changes. The success screen reads `message` and
  // `filesAttached` from the result object.
  const recipients = Array.isArray(data?.recipients) ? data.recipients : [];
  const salusNote  = data?.salus?.sent ? ' (+ Salus Pro)' : '';
  return {
    message:       `Sent to ${recipients.length || 1} recipient(s)${salusNote}`,
    filesAttached: 1,
    recipients,
    salus:         data?.salus || { sent: false },
    from:          data?.from || '',
  };
}
